// Template232: Kuala Lumpur - Más consejos (Tips2.jsx)
// Header, list of tips from data.tips, info box "Apps útiles" (HTML).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template232 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;
	const infoBoxContent = page?.texts?.[1]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";
	const tips = Array.isArray(page?.data?.tips)
		? page.data.tips
		: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "16px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
				}}
			>
				{tips.map((tip, idx) => (
					<Box
						key={idx}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #dee7e3",
						}}
					>
						<Box component="span" sx={{ fontSize: 18 }}>
							{tip.icono}
						</Box>
						<Box component="span" sx={{ fontSize: 13, color: contentColor }}>
							{tip.texto}
						</Box>
					</Box>
				))}

				{infoBoxContent && (
					<Box
						data-block-id="text-apps"
						sx={{
							backgroundColor: "#dee7e3",
							border: "2px solid #2E7D5B",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 12,
							marginTop: 1,
							position: "relative",
							color: contentColor,
						}}
						dangerouslySetInnerHTML={{ __html: infoBoxContent }}
					/>
				)}

				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							top: isSmallScreen ? "92%" : "50%",
							right: 0,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template232.thumbnail = "/images/template-1.png";
export default Template232;
